"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = require("./datapoints");
var moveMailListRows_1 = require("./moveMailListRows");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Archive mail list rows from table
 * @param rowKeys the instance keys of the rows to archive
 * @param tableView the table view that contains the rows to archive
 * @param actionSource the action source that triggers the archive action
 */
exports.default = legacy_1.select({
    archiveFolderId: function () { return getUserConfiguration_1.default().UserOptions.ArchiveFolderId; },
})(legacy_1.action('archiveMailListRowsFromTable', datapoints_1.default.archiveMailListRowsDatapoint)(function archiveMailListRowsFromTable(rowKeys, tableView, actionSource, state) {
    if (state.archiveFolderId) {
        moveMailListRows_1.default(rowKeys, state.archiveFolderId, tableView.id, 'NonUserAction');
    }
    else {
        // For new accounts and the existing accounts which have not setup the archive folder
        // the archive folder should get created as a default folder.
        throw new Error('Archive folder id should always be set');
    }
}));
//# sourceMappingURL=archiveMailListRows.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/archiveMailListRows.js
// module id = 5606
// module chunks = 62